window.theme = window.theme || {};

window.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth <= 768) {
    const menuTitles = document.querySelectorAll('.footer_inner_blocks .footer__title');

    menuTitles.forEach((title) => {
      const siblingDiv = title.nextElementSibling;

      // Initially hide the sibling div
      if (siblingDiv) {
        siblingDiv.style.display = 'none';
      }

      // Add click event
      title.addEventListener('click', () => {
        title.classList.toggle('active');

        if (siblingDiv) {
          if (siblingDiv.style.display === 'none') {
            siblingDiv.style.display = 'block';
          } else {
            siblingDiv.style.display = 'none';
          }
        }
      });
    });
  }
  
});

